class PossibleDiscussions {
    public HasGeneticAdvice: boolean;
    public HasTravel: boolean;
    public HasSexualActivity: boolean;
    public HasExerciseSports: boolean;
    public HasPrenatalClasses: boolean;
    public HasMedicalAvailability: boolean;
    public HasNutrition: boolean;
    public HasConjugalViolence: boolean;
    public HasHospitalRoutine: boolean;
    public HasBirthingCoach: boolean;
    public HasBirthingRoom: boolean;
    public HasSupervisionDuringLabour: boolean;
    public HasMonitoring: boolean;
    public HasWorriesFear: boolean;
    public HasStbbiRisks: boolean;
    public HasAnesthesiaPainRelief: boolean;
    public HasVacuumExtractorForceps: boolean;
    public HasEpisiotomy: boolean;
    public HasPerinealMassage: boolean;
    public HasCaesarianBirth: boolean;
    public HasDeliveryPositionTechniques: boolean;
    public HasNeonatalBloodUrineScreening: boolean;
    public HasHospitalStay: boolean;
    public HasCohabitation: boolean;
    public HasNursing: boolean;
    public HasCircumcision: boolean;
    public HasContraception: boolean;
    public HasFinancialResources: boolean;
    public HasResourcesAtHome: boolean;
    public Comments: string;

    constructor(fields?: Partial<PossibleDiscussions>) {
        Object.assign(this, fields);
    }
}

export { PossibleDiscussions };
